export enum APPOINTMENT_SCHEDULE_ADVANCE_UNIT {
  HOUR = 'hour',
  DAY = 'day',
}
